//@ts-check
/**
 * A limit the server enforces on what one person can keep (guides/DYNAMODB.md, "Limits"): which
 * one was reached, and its number, so the screen can say it in its own words. Null for any other
 * refusal.
 *
 * @param {any} err a ky error, with `body` from $lib/utils/utils.js
 * @returns {{ limit: string, max: number } | null}
 */
export function limitReached(err) {
  if (err?.response?.status !== 409 || err?.body?.code !== "limit") return null;
  return { limit: String(err.body.limit), max: Number(err.body.max) };
}
